// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
import type { ProjectStatus } from "./ProjectStatus";
import {
  ProjectStatusFromJSON,
  ProjectStatusFromJSONTyped,
  ProjectStatusToJSON,
  ProjectStatusToJSONTyped,
} from "./ProjectStatus";
import type { User } from "./User";
import { UserFromJSON, UserFromJSONTyped, UserToJSON, UserToJSONTyped } from "./User";
import type { Point } from "./Point";
import { PointFromJSON, PointFromJSONTyped, PointToJSON, PointToJSONTyped } from "./Point";

/**
 *
 * @export
 * @interface ProjectRead
 */
export interface ProjectRead {
  /**
   *
   */
  id: string;
  /**
   *
   */
  createdAt: Date;
  /**
   *
   */
  updatedAt: Date;
  /**
   *
   */
  status?: ProjectStatus;
  /**
   *
   */
  code: string;
  /**
   *
   */
  slug?: string;
  /**
   *
   */
  name: string;
  /**
   *
   */
  description: string;
  /**
   *
   */
  fileLakeId?: string | null;
  /**
   *
   */
  location?: Point | null;
  /**
   *
   */
  locationName?: string | null;
  /**
   *
   */
  clientName?: string | null;
  /**
   *
   */
  showOnboarding: boolean;
  /**
   *
   */
  creator: User;
  /**
   *
   */
  lastActivity: Date;
  /**
   *
   */
  contributors: Array<User>;
}

/**
 * Check if a given object implements the ProjectRead interface.
 */
export function instanceOfProjectRead(value: object): value is ProjectRead {
  if (!("id" in value) || value["id"] === undefined) return false;
  if (
    (!("createdAt" in (value as Record<string, any>)) &&
      !("created_at" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["createdAt"] === undefined &&
      (value as Record<string, any>)["created_at"] === undefined)
  )
    return false;
  if (
    (!("updatedAt" in (value as Record<string, any>)) &&
      !("updated_at" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["updatedAt"] === undefined &&
      (value as Record<string, any>)["updated_at"] === undefined)
  )
    return false;
  if (!("code" in value) || value["code"] === undefined) return false;
  if (!("name" in value) || value["name"] === undefined) return false;
  if (!("description" in value) || value["description"] === undefined) return false;
  if (
    (!("showOnboarding" in (value as Record<string, any>)) &&
      !("show_onboarding" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["showOnboarding"] === undefined &&
      (value as Record<string, any>)["show_onboarding"] === undefined)
  )
    return false;
  if (!("creator" in value) || value["creator"] === undefined) return false;
  if (
    (!("lastActivity" in (value as Record<string, any>)) &&
      !("last_activity" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["lastActivity"] === undefined &&
      (value as Record<string, any>)["last_activity"] === undefined)
  )
    return false;
  if (!("contributors" in value) || value["contributors"] === undefined) return false;
  return true;
}

export function ProjectReadFromJSON(json: any): ProjectRead {
  return ProjectReadFromJSONTyped(json, false);
}

export function ProjectReadFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectRead {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"],
    createdAt: json["created_at"] == null ? json["created_at"] : parseDateTime(json["created_at"]),
    updatedAt: json["updated_at"] == null ? json["updated_at"] : parseDateTime(json["updated_at"]),
    status: json["status"] == null ? undefined : ProjectStatusFromJSON(json["status"]),
    code: json["code"],
    slug: json["slug"] == null ? undefined : json["slug"],
    name: json["name"],
    description: json["description"],
    fileLakeId:
      json["file_lake_id"] === undefined
        ? undefined
        : json["file_lake_id"] === null
        ? null
        : json["file_lake_id"],
    location:
      json["location"] === undefined
        ? undefined
        : json["location"] === null
        ? null
        : PointFromJSON(json["location"]),
    locationName:
      json["location_name"] === undefined
        ? undefined
        : json["location_name"] === null
        ? null
        : json["location_name"],
    clientName:
      json["client_name"] === undefined
        ? undefined
        : json["client_name"] === null
        ? null
        : json["client_name"],
    showOnboarding: json["show_onboarding"],
    creator: UserFromJSON(json["creator"]),
    lastActivity:
      json["last_activity"] == null ? json["last_activity"] : parseDateTime(json["last_activity"]),
    contributors: (json["contributors"] as Array<any>).map(UserFromJSON),
  };
}

export function ProjectReadToJSON(json: any): ProjectRead {
  return ProjectReadToJSONTyped(json, false);
}

export function ProjectReadToJSONTyped(
  value?: ProjectRead | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value["id"],
    created_at:
      value["createdAt"] == null ? value["createdAt"] : serializeDateTime(value["createdAt"]),
    updated_at:
      value["updatedAt"] == null ? value["updatedAt"] : serializeDateTime(value["updatedAt"]),
    status: ProjectStatusToJSON(value["status"]),
    code: value["code"],
    slug: value["slug"],
    name: value["name"],
    description: value["description"],
    file_lake_id: value["fileLakeId"],
    location: PointToJSON(value["location"]),
    location_name: value["locationName"],
    client_name: value["clientName"],
    show_onboarding: value["showOnboarding"],
    creator: UserToJSON(value["creator"]),
    last_activity:
      value["lastActivity"] == null
        ? value["lastActivity"]
        : serializeDateTime(value["lastActivity"]),
    contributors: (value["contributors"] as Array<any>).map(UserToJSON),
  };
}
